module.exports = "<h2>Shipping</h2>\n<div class=\"row\" *ngIf=\"cart$ | async as cart\">\n  <div class=\"col-6\">\n    <shipping-form [cart]=\"cart\"></shipping-form>\n  </div>\n  <div class=\"col-6\">\n    <shopping-cart-summary [cart]=\"cart\"></shopping-cart-summary>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/dev1/Aladin-SHOP/src/app/shopping/components/check-out/check-out.component.html
// module id = ../../../../../src/app/shopping/components/check-out/check-out.component.html
// module chunks = main